import Head from 'next/head';
import { isIE } from 'react-device-detect';
import { IEAlert } from '../IEAlert';
import { Header } from './Header';
import { Footer } from './Footer';

export const Layout = ({ children }: { children: React.ReactNode; home?: boolean }) => (
  <>
    {isIE && <IEAlert />}
    <Head>
      <link rel="icon" href="/images/onvista/favicon.ico" />
    </Head>
    <Header />
    <main>{children}</main>
    <Footer />
  </>
);
